import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { authActions, MailCheckType } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";

export const useChangeEmail = () => {
  const dispatch = useDispatch();
  const { navigateToTopPage, navigateToPage } = useNavigation();
  const { key } = useParams<{ key: string }>();

  useEffect(() => {
    if (!key) return;

    dispatch(appActions.showLoading());
    dispatch(
      authActions.verifyEmailKey.started({
        key,
        type: MailCheckType.ChangeEmail.valueOf(),
        onComplete: () => dispatch(appActions.hideLoading()),
        onError: navigateToTopPage,
      }),
    );
  }, []);

  const handleChangeEmail = useCallback((code: string, phoneNumber: string) => {
    dispatch(appActions.showLoading());
    dispatch(
      authActions.changeEmail.started({
        key: key ?? "",
        code,
        tel: phoneNumber,
        // TODO: change to selected language
        lang: "ja",
        onComplete: () => dispatch(appActions.hideLoading()),
        onSuccess: () =>
          navigateToPage(PageRoutes.CHANGE_EMAIL_REGISTRATION_MESSAGE),
      }),
    );
  }, []);

  return { handleChangeEmail };
};
